import { API_URL } from 'src/config/environment'
import apiCreator from '../api-creator'

type GetPresignedS3UploadLinkResponse = {
  url: string;
}

export async function getPresignedS3UploadLink(
  filename: string,
  complianceType: string,
  abortSignal: AbortSignal,
): Promise<GetPresignedS3UploadLinkResponse> {
  return apiCreator
    .get<GetPresignedS3UploadLinkResponse>(
      `${API_URL.SCIFINDER}/get-upload-url`,
      {
        params: {
          filename: filename,
          compliance_type: complianceType,
        },
        signal: abortSignal,
      },
    )
    .then(({ data }) => data)
}
